import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getStatementList as getStatementListApi,
	getStatement as getStatementApi,
	addNewStatement as addNewStatementApi,
	updateStatement as updateStatementApi,
	deleteStatement as deleteStatementApi,
	getDataResiduesStatement as getDataResiduesStatementApi
} from '../../helpers/residue/backend_helper';

export const getStatementList = createAsyncThunk('statements/getStatementList', async (params) => {
	try {
		const response = getStatementListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getStatement = createAsyncThunk('statements/getStatement', async statement_id => {
	try {
		const response = getStatementApi(statement_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewStatement = createAsyncThunk('statements/addNewStatement', async statement => {
	try {
		const response = addNewStatementApi(statement);
		toast.success('Certificado de Declaración agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar statement.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateStatement = createAsyncThunk('statements/updateStatement', async (statement) => {
		try {
			const response = updateStatementApi(statement);
			toast.success('Certificado de Declaración actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar statement.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteStatement = createAsyncThunk('statements/deleteStatement', async statement => {
	try {
		const response = await deleteStatementApi(statement);
		toast.success('Certificado de Declaración eliminado exitosamente.', { autoClose: 3000 });
		return { statement, ...response };
	} catch (error) {
		toast.error('Error al eliminar statement.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getDataResiduesStatement = createAsyncThunk('statements/getDataResiduesStatement', async statement_id => {
	try {
		const response = getDataResiduesStatementApi(statement_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});